var cilCommentSquare = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M496,496H448.771L379.249,368H40a24.028,24.028,0,0,1-24-24V40A24.028,24.028,0,0,1,40,16H472a24.028,24.028,0,0,1,24,24ZM48,336H398.284L464,456.993V48H48Z' class='ci-primary'/>"];

export { cilCommentSquare };

